
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/nomoredebttoday",
      function () {
        return require("private-next-pages/nomoredebttoday/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/nomoredebttoday"])
      });
    }
  